<template lang="html">
  <div>
    <div class="flex middle-xs justify-center">
      <pl-spinner v-if="loading_wordcloud" class="x4" />
      <img
        v-else-if="!show_cloud_svg && !loading_wordcloud"
        src="/static/cloud_empty.png"
        alt="word cloud"
        class="empty-cloud"
      />
      <div
        class="wordcloud-container"
        v-show="show_cloud_svg && !loading_wordcloud"
      >
        <div style="max-width: 700px" v-html="svg_data" />
      </div>
      <pl-button
        v-if="!loading_wordcloud"
        @click.native="show_info = true"
        class="pl-icon"
      >
        <i class="fas fa-info-circle" />
      </pl-button>
      <pl-dialog
        v-if="show_info"
        @close="show_info = false"
        header="The Idea Cloud analyzes the RoundTable for frequent words across
        student submissions."
      >
        <p class="italics pl-subheading tc">
          The bigger the word in the cloud, the more times it was used!
        </p>
        <section
          class="flex justify-center items-center ma3"
          v-if="hasTeacherPermissionsInCourse"
        >
          <p class="mr3 pl-caption">
            Share this visual and become a
            <b class="link-to-blog" @click="toBlogPost">Parlay Trailblazer!</b>
          </p>
          <template v-if="show_cloud_svg">
            <img
              src="/static/shareOnTW.svg"
              @click="shareOnTW"
              class="social-icons clickable"
            />
            <img
              src="/static/shareOnFB.svg"
              @click="shareOnFB"
              class="social-icons clickable"
            />
          </template>
          <template v-else>
            <img src="/static/shareOnTW_disabled.svg" class="social-icons" />
            <img src="/static/shareOnFB_disabled.svg" class="social-icons" />
          </template>
        </section>
        <pl-button @click.native="show_info = false" class="pl-primary">
          OK
        </pl-button>
      </pl-dialog>
    </div>
  </div>
</template>

<script>
  import {
    createIdeaCloud,
    createSandboxIdeaCloud,
  } from 'features/onlineRoundtables/services/dataVisualization/createIdeaCloud';
  import URLPath from 'services/apiConfigs';
  import { mapGetters } from 'vuex';
  import allowSharing from 'features/onlineRoundtables/services/dataVisualization/allowSharing';

  export default {
    data() {
      return {
        svg_data: '',
        loading_wordcloud: false,
        show_cloud_svg: false,
        show_info: false,
      };
    },
    computed: {
      sharing_url() {
        const roundtableID = this.$route.params.roundtableID;
        return `${URLPath.apiURL}/api/roundtables/${roundtableID}/idea-cloud-public`;
      },
      ...mapGetters(['getCurrentRT', 'hasTeacherPermissionsInCourse']),
      is_sharing_allowed() {
        return this.getCurrentRT.sharing_settings.idea_cloud;
      },
    },
    methods: {
      toBlogPost() {
        window.open(
          'https://parlayideas.com/revolutionize-discussion-become-a-parlay-trailblazer/'
        );
      },
      setAllowingToTrue() {
        if (this.is_sharing_allowed) {
          // Return empty promise to allow a .then() in all scenarios
          return Promise.resolve(null);
        }
        const rt_id = this.getCurrentRT.id;
        const body = { idea_cloud: true };
        const sharing_settings = Object.assign(
          {},
          this.getCurrentRT.sharing_settings,
          body
        );
        this.$store.dispatch('updateRTDetails', { sharing_settings });
        return allowSharing(rt_id, body);
      },
      shareOnFB() {
        // this.setAllowingToTrue().then(() => {
        //   FB.ui(
        //     {
        //       method: 'share',
        //       href: this.formatParam(this.sharing_url),
        //     },
        //     function (response) {}
        //   );
        // });
      },
      shareOnTW() {
        this.setAllowingToTrue().then(() => {
          const rtTitle = this.getCurrentRT.title;
          const url = this.formatParam(this.sharing_url);
          const text = this.formatParam(
            `Check out this Idea Cloud from our class discussion "${rtTitle}" on @parlayideas`
          );
          window.open(
            `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
            '',
            'scrollbars=yes,width=650,height=280'
          );
        });
      },
      formatParam(param) {
        return param
          .replace(/%/g, '%25')
          .replace(/ /g, '%20')
          .replace(/\$/g, '%24')
          .replace(/#/g, '%23');
      },
      handleIdeaCloudResponse(resp) {
        this.svg_data = resp.data;
        this.loading_wordcloud = false;
        const group = document.getElementsByClassName('mark-text');
        return setTimeout(() => {
          let displayedWords = 0;
          const childNodes = group[0].childNodes;
          childNodes.forEach((node, index) => {
            if (node.style.fontSize !== '0px') {
              displayedWords += 1;
            }
          });
          if (displayedWords > 5) {
            this.show_cloud_svg = true;
          }
        }, 0);
      },
    },
    mounted() {
      this.loading_wordcloud = true;
      if (this.$route.name === 'walkthrough.feed') {
        this.show_cloud_svg = true;
        createSandboxIdeaCloud().then((res) => {
          this.svg_data = res.data;
          this.loading_wordcloud = false;
          this.show_cloud_svg = true;
        });
      } else {
        const roundtableID = this.$route.params.roundtableID;
        createIdeaCloud(roundtableID)
          .then(this.handleIdeaCloudResponse)
          .catch(console.error);
      }

      // Facebook Init
      // window.fbAsyncInit = function () {
      //   FB.init({
      //     appId: '1550372328564661',
      //     autoLogAppEvents: true,
      //     xfbml: true,
      //     version: 'v2.12',
      //   });
      // };

      // (function (d, s, id) {
      //   var js,
      //     fjs = d.getElementsByTagName(s)[0];
      //   if (d.getElementById(id)) {
      //     return;
      //   }
      //   js = d.createElement(s);
      //   js.id = id;
      //   js.src = 'https://connect.facebook.net/en_US/sdk.js';
      //   fjs.parentNode.insertBefore(js, fjs);
      // })(document, 'script', 'facebook-jssdk');
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .description-container
    padding: 0 20px

  .buttons-container
    padding-left: 10px

  .social-icons
    height: 25px
    margin: 0px 10px

  .empty-cloud
    width: 30em
    height: 15em

  .link-to-blog:hover
    cursor: pointer
    cursor: hand
    text-decoration: underline
</style>



// WEBPACK FOOTER //
// roundtableSummaryWordCloud.vue?d835dbe2